<template>
    <div id="app">
        <container></container>

    <div class="bg-right-orange"></div>

    </div>
</template>

<script>
// import CookieLaw from "vue-cookie-law"
import container from "./views/Container"

export default {
    components: { container  },
    data() {
        return {}
    },
    mounted() {
        this.$router.afterEach((to, from) => {
            this.$nextTick(() => {
                // document.querySelector("#content-conatiner").scrollTo({top: 0, behavior: 'smooth'})
            })
        })
        this.$store.dispatch("listJourneys")
        this.$store.dispatch("listContents")
        this.$store.dispatch("listCategories")
        this.$store.dispatch("listCountries")
    },
    methods: {

        navigate(link, forceLoad = false) {
          if(link == this.oldLink){return;}
          this.oldLink = link;
          core.navigate({ path: link }, forceLoad)
        }
    }
}
</script>

<style>
#app {
  position: relative;
  min-height: 100vh;
}

</style>
